/**
 * Canonical task enum value sets — single cross-app source.
 *
 * `TASK_STATUS_VALUES` mirrors the Postgres `task_status` enum
 * (contact_tasks.status). apps/hub anchors this array against its codegen
 * `Task_Status` union (lib/constants/task-enums.ts `satisfies` check), so a DB
 * enum migration + `npm run codegen` in hub surfaces any drift as a tsc error.
 *
 * `TASK_PRIORITY_VALUES` has NO backing DB enum (priority is varchar); this is
 * the single app-level source so every task form agrees.
 *
 * `TASK_NOTE_TYPE_VALUES` is for `task_notes.note_type` (varchar) — not the
 * contact `note_type` enum.
 */
export const TASK_STATUS_VALUES = [
    "pending",
    "in_progress",
    "completed",
    "cancelled",
];
export const TASK_PRIORITY_VALUES = ["low", "medium", "high", "urgent"];
/**
 * `task_notes.note_type` — plain text column. Production currently has
 * general/internal; `client` is an allowed write value used by Meridian
 * task-note tools.
 */
export const TASK_NOTE_TYPE_VALUES = ["general", "internal", "client"];
/**
 * Due-date buckets accepted by Hub's `GET /api/workspace-addon/tasks?filter=`
 * list route. Buckets resolve in WTC Central time on the server; `all` includes
 * undated tasks, the date buckets exclude them.
 */
export const TASK_LIST_FILTERS = ["all", "today", "overdue", "week"];
